import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  BASE_REQUEST_TYPE,
  ETAB_NUMBER_SUB_DETAIL,
  PURCHASE_HISTORY_PARAMS_REQUEST,
  PURCHASE_HISTORY_STATE,
  SITTER_AC_PARAMS_REQUEST,
  SITTER_AC_STATE,
  SUBSCRIPTION_DETAIL_TYPE,
  SUBSCRIPTION_PARAMS_REQUEST,
  SUBSCRIPTION_STATE,
} from 'models/subscription';

export interface SUBSCRIPTION {
  subscription: {
    subscription_list: SUBSCRIPTION_STATE;
    subscription_detail: SUBSCRIPTION_DETAIL_TYPE | null;
    base_request_detail: BASE_REQUEST_TYPE | null;
    sitter_added_into_ac_job_list: SITTER_AC_STATE;
    purchaseHistoryList: PURCHASE_HISTORY_STATE;
    tabActive: ETAB_NUMBER_SUB_DETAIL;
  };
}

const initialState: SUBSCRIPTION = {
  subscription: {
    subscription_list: {
      records: [],
      metadata: {
        page: 1,
        limit: 50,
        page_count: 1,
        total_pages: 1,
        total_count: 1,
      },
      params: { page: 1, limit: 50 },
    },
    sitter_added_into_ac_job_list: {
      data: [],
      metadata: {
        page: 1,
        limit: 50,
        page_count: 1,
        total_pages: 1,
        total_count: 1,
      },
      params: { page: 1, limit: 50 },
    },
    subscription_detail: null,
    base_request_detail: null,
    purchaseHistoryList: {
      params: { page: 1, limit: 50 },
      metadata: {
        page: 1,
        limit: 50,
        page_count: 1,
        total_pages: 1,
        total_count: 1,
      },
      records: [],
    },
    tabActive: ETAB_NUMBER_SUB_DETAIL.SITTERS,
  },
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    updateTabActive(
      state: SUBSCRIPTION,
      action: PayloadAction<ETAB_NUMBER_SUB_DETAIL>
    ) {
      state.subscription.tabActive = action.payload;
    },
    setSubscriptionListSuccess(
      state: SUBSCRIPTION,
      action: PayloadAction<SUBSCRIPTION_STATE>
    ) {
      state.subscription.subscription_list = {
        ...state.subscription.subscription_list,
        ...action.payload,
      };
    },
    setSubscriptionListParams(
      state: SUBSCRIPTION,
      action: PayloadAction<SUBSCRIPTION_PARAMS_REQUEST | null>
    ) {
      state.subscription.subscription_list.params = action.payload;
    },
    setSubscriptionDetailSuccess(
      state: SUBSCRIPTION,
      action: PayloadAction<SUBSCRIPTION_DETAIL_TYPE | null>
    ) {
      state.subscription.subscription_detail = action.payload;
    },
    setBaseRequestDetailSuccess(
      state: SUBSCRIPTION,
      action: PayloadAction<BASE_REQUEST_TYPE | null>
    ) {
      state.subscription.base_request_detail = action.payload;
    },
    setSitterAddedIntoACJobListSuccess(
      state: SUBSCRIPTION,
      action: PayloadAction<SITTER_AC_STATE>
    ) {
      state.subscription.sitter_added_into_ac_job_list = {
        ...state.subscription.sitter_added_into_ac_job_list,
        ...action.payload,
      };
    },
    setSitterACListParams(
      state: SUBSCRIPTION,
      action: PayloadAction<SITTER_AC_PARAMS_REQUEST | null>
    ) {
      state.subscription.sitter_added_into_ac_job_list.params = action.payload;
    },
    setPurchaseHistorySuccess(
      state: SUBSCRIPTION,
      action: PayloadAction<PURCHASE_HISTORY_STATE>
    ) {
      state.subscription.purchaseHistoryList = {
        ...state.subscription.purchaseHistoryList,
        ...action.payload,
      };
    },
    setPurchaseHistoryListParams(
      state: SUBSCRIPTION,
      action: PayloadAction<PURCHASE_HISTORY_PARAMS_REQUEST>
    ) {
      state.subscription.purchaseHistoryList.params = action.payload;
    },
  },
});

// Actions
export const {
  setSubscriptionListSuccess,
  setSubscriptionListParams,
  setSubscriptionDetailSuccess,
  setBaseRequestDetailSuccess,
  setSitterAddedIntoACJobListSuccess,
  setSitterACListParams,
  setPurchaseHistorySuccess,
  setPurchaseHistoryListParams,
  updateTabActive,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
